const allAdDomains = {
  valid: 'https://httpstat.us/200',
  invalid: [
    'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js',
    'https://connect.facebook.net/en_US/fbevents.js',
    'https://google-analytics.com/analytics.js',
    'https://c.amazon-adsystem.com/aax2/apstag.js',
    'https://yandex.ru/ads/system/context.js'
  ]
}

const allFakeDomains = {
  valid: 'https://probe.ping-domain.site/ping',
  invalid: [
    'https://probe.ping-domain.site/prebid/prebid.js',
    'https://probe.ping-domain.site/prebid/prebid.min.js',
    'https://probe.ping-domain.site/prebid/adapters.js',
    'https://probe.ping-domain.site/prebid/banner.js',
    'https://probe.ping-domain.site/prebid/adscript.js'
  ]
}

function applyScript(url, isTrusted = false) {
  return new Promise((resolve) => {
    const script = document.createElement('script')
    let finished = false

    const finish = (result) => {
      if (!finished) {
        finished = true
        script.onload = null
        script.crossorigin = 'anonymous'
        script.onerror = null
        script.remove()
        resolve(result)
      }
    }
    script.src = url
    script.async = true
    script.onload = () => finish(isTrusted) // ?
    script.onerror = () => finish(true)
    document.head.appendChild(script)
  })
}

async function makeReport(data) {
  const isOk = await applyScript(data.valid, true)
  let report
  if (isOk) {
    const testResults = await Promise.all(
      data.invalid.map((domain) => applyScript(domain))
    )
    report = testResults.map((result, index) => ({
      domain: data.invalid[index],
      blocked: result
    }))
  }
  return report
}

export default async function adBlockDetector() {
  const isBraveBrowser = await navigator.brave && navigator.brave.isBrave()
  const isFirefoxBrowser = navigator.userAgent.includes('Firefox')
  const actualDomainList = isBraveBrowser || isFirefoxBrowser ? allFakeDomains : allAdDomains

  const report = await makeReport(actualDomainList)
  if (report === undefined) return report

  return report.reduce((acc, currentRequest) => {
    if (currentRequest.blocked) {
      acc.blocked += 1
    }
    acc.total += 1
    return acc
  }, {
    blocked: 0,
    total: 0
  })
}
